import React, { Component } from 'react';
import Layout from "../Layout";

import { Select, Button, Input, Textarea } from "~/js/partials";
import { isInitialValid, processRegions, groupDealerships, formatGroupLabel } from "~/js/utils";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { formsService } from '~/js/_services';
import { favouritesService } from '~/js/_services';
import Turnstile from "react-turnstile";
import {addEmailPhoneDatalayer} from "../../../utils";

const vehicle = window.current_vehicle ?? null;
const dealer = window.current_dealer ?? null;

let dealershipsGrouped = [];
class FormMakeAnEnquiry extends Component {

    state = {
        formDealerID: null,
        dealership: null,
        dealerships: dealershipsGrouped,
        turnstileToken : "",
    };

    componentDidMount() {
        dealershipsGrouped = groupDealerships(this.props.regions)
        this.favouritesSubscription = favouritesService.current.subscribe(f => {
            this.setState({
                favourites: f,
            })
        });
        this.updateDealers();

        this.checkForm();
    };

    componentWillUnmount() {
        this.favouritesSubscription.unsubscribe();
    }

    componentDidUpdate(prevProps){
        if (this.props.type !== prevProps.type) {
            if (this.formik) this.formik.resetForm();
            this.checkForm();
        }
    }

    updateDealers = () => {

        let matchingDealerIDs = [];

        dealershipsGrouped.forEach(region => {
            if(region.options){
                region.options.forEach(dealer => {
                    if(window.current_brand){
                        if (dealer.dealer.data['dealership-details'] && dealer.dealer.data['dealership-details'].brand) {
                            if (dealer.dealer.data['dealership-details'].brand.find(br => (br.ID == window.current_brand.id))) {
                                matchingDealerIDs.push(dealer.dealer.ID);
                            }
                        }
                        if (dealer.dealer.data['dealership-details'] && dealer.dealer.data['dealership-details']['other-brand']) {
                            if (dealer.dealer.data['dealership-details']['other-brand'].find(br => (br.ID == window.current_brand.id))) {
                                matchingDealerIDs.push(dealer.dealer.ID);
                            }
                        }
                    }
                })
            }
        })

        let clonedDealers = JSON.parse(JSON.stringify(dealershipsGrouped))

        clonedDealers.forEach(region => {
            if(region.options){
                let newOptions = [];
                region.options.forEach((dealer, i) => {
                    if (matchingDealerIDs.includes(dealer.dealer.ID)){
                        newOptions.push(region.options[i])
                    }
                })
                region.options = newOptions
            }
        })

        // reset clonedDealers if theres none in there
        let foundDealers = false;
        clonedDealers.forEach(region => {
            if(region.options && region.options.length > 0){
                foundDealers = true;
            }
        })

        if(foundDealers){
            if(window.current_brand){
                clonedDealers[0].label = `Select from ${window.current_brand.name } Dealerships`
            }
        }else{
            clonedDealers = JSON.parse(JSON.stringify(dealershipsGrouped))
        }

        this.setState({dealerships: clonedDealers})
    };


    checkForm = () => {
        const dealer  = window.current_dealer;

        this.updateDealers();

        // Preselect dealer
        if (dealer) {
            if (this.formik) this.formik.setFieldValue('dealership', dealer['post_title']);
            this.setState({ formDealerID: dealer['ID'] });
        }
        if(vehicle){
            if (this.formik) this.formik.setFieldValue('stockNumber', vehicle['@LISTING_STOCK_NO']);

        }
    };

    handleSubmit = (fields, { setStatus, setSubmitting }) => {
        const { showSuccessPopup, type } = this.props;
            // Reset status, if there where errors
            setStatus();

            let turnstileData = {
                response: this.state.turnstileToken,
            }

            //check Turnstile Backend Verification
            formsService.turnstileVerification(turnstileData).then((response) => {
                if(response.data.success){
                    let data = {
                        name: 'Make An Enquiry Passed Email',
                        fields: JSON.parse(JSON.stringify(fields)),
                        passedEmail: this.props.passedEmail,
                    };
                    data.fields.formDealerID = this.state.formDealerID;

                    if(this.autoplayCampaignId){
                        data.fields.autoplayCampaignId = this.autoplayCampaignId;
                    }
                    formsService.makeAnEnquiry(data).then(
                        success => {
                            const title = "Your submission is successful"
                            const text = "We will contact you about your booking."
                            showSuccessPopup({ title, text });
                            setSubmitting(false);

                            let formType = this.props.type;

                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'FormSubmit',
                                'formType': formType,
                                'phone': data.fields.phone,
                                'email': data.fields.email
                            });
                        },
                        error => {
                            setSubmitting(false);
                            setStatus(error.message);
                        }
                    );
                }else{
                    setSubmitting(false);
                    setStatus("Error with Turnstile Verification");
                }
            });


    };

    renderForm = (props) => {
        const { isValid, isSubmitting, status } = props;
        const passedEmail = (this.props.passedEmail);
        let stockNumber = "";
        if(vehicle) {
            stockNumber = vehicle['@LISTING_STOCK_NO'];
        }

        this.state.dealership = dealer;

        let extraClass = 'form-make-an-enquiry';


        return (
            <Form className="popup-form__form">
                <div className="popup-form__group">
                    <div className="popup-form__label">Personal details</div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`firstName`}
                                placeholder={`First Name`}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                        <div className="popup-form__col">
                            <Input
                                name={`lastName`}
                                placeholder={`Last Name`}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`phone`}
                                placeholder={`Phone`}
                                modifiers={['form']}
                                form={props}
                                type="tel"
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`email`}
                                placeholder={`Email (optional)`}
                                modifiers={['form']}
                                form={props}
                                type="email"
                            />
                        </div>
                    </div>
                    <div className="popup-form__group">
                        <div className="popup-form__label">Dealership</div>
                        <div className="popup-form__row">
                            <div className="popup-form__col">
                                <Select
                                    name={`dealership`}
                                    form={props}
                                    options={this.state.dealerships}
                                    onChange={(dealer) => {
                                        let id = dealer.dealer ? dealer.dealer.ID : null
                                        if (id !== this.state.formDealerID) {
                                            this.setState({ formDealerID: id })
                                        }
                                    }}
                                    isDisabled={dealer ? true : false}
                                    formatGroupLabel={formatGroupLabel}
                                    modifiers={['form']}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="popup-form__group pb-3">
                    <div className="popup-form__label">Your message</div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Textarea
                                name={`message`}
                                placeholder={`Add your message`}
                                form={props}
                            />
                        </div>
                    </div>
                </div>
                {vehicle &&
                    <Input
                        name={`stockNumber`}
                        modifiers={['form']}
                        type={`hidden`}
                        value={stockNumber}
                    />
                }
                {/*<Input*/}
                {/*    name={`passedEmail`}*/}
                {/*    modifiers={['form']}*/}
                {/*    type={`hidden`}*/}
                {/*    value={passedEmail}*/}
                {/*/>*/}

                {status &&
                <div className={'popup-form__alert pb-3'}>{status}</div>
                }
                <Turnstile
                    sitekey={process.env.TURNSTILE_SITE_KEY}
                    onVerify={(token) => {
                        this.setState({turnstileToken : token});
                    }}
                    theme={'light'}
                />

                <div className="popup-form__submit">
                    <Button

                        extraClass={extraClass}
                        title={`Submit details`}
                        modifiers={['solid', 'medium']}
                        chevron={true}
                        type="submit"
                        disabled={!this.state.turnstileToken}
                        loading={isSubmitting}
                    />
                </div>
            </Form>
        );
    }
    validate(){


    }
    get isDealership(){
        return window.current_dealer;
    }
    get autoplayCampaignId(){
        if(document.querySelector('#form-campaign-id')){
            return document.querySelector('#form-campaign-id').innerText ;
        }else{
            return false;
        }
    }


    render() {
        const { ...rest } = this.props;
        const title = `Make an enquiry`;
        const text = `Fill in your details below and we’ll get back to you `;

        const initialValues = {
            firstName: '',
            lastName: '',
            message: '',
            passedEmail: '',
            email: '',
            phone: '',
            zapierUrl: window.location.href,

        };
        const validationSchema = Yup.object().shape({
            firstName: Yup.string().required('Required'),
            lastName: Yup.string().required('Required'),
            message: Yup.string().required('Required'),
            dealership: this.isDealership ? Yup.string().required('Required') : Yup.string(),
            email: Yup.string().email('Invalid email'),
            phone: Yup.string().required('Required'),
        });

        const other = {};
        return (
            <Layout
                title={title}
                text={text}
                {...rest}
                {...other}
            >
                <Formik
                    isInitialValid={isInitialValid}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={this.handleSubmit}
                    children={this.renderForm}
                >
                    {formikProps => {
                        this.formik = formikProps;
                        return this.renderForm(formikProps);
                    }}
                </Formik>
            </Layout>
        );
    }
}

export default FormMakeAnEnquiry;
